import { render, staticRenderFns } from "./ContentRightsSummary.vue?vue&type=template&id=1805fd0f&scoped=true&"
import script from "./ContentRightsSummary.vue?vue&type=script&lang=js&"
export * from "./ContentRightsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ContentRightsSummary.vue?vue&type=style&index=0&id=1805fd0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1805fd0f",
  null
  
)

export default component.exports